export const contactsData = {
    email: 'shubhamsri0807@gmail.com',
    phone: '+919067153883',
    address: 'Ho No.91,3rd A cross, PR Layout Munnekolala, Marathahalli, Bangalore, Karnataka-560037',

    sheetAPI: ''
}